import React from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import SearchIcon from "../../assets/icons/search.svg2";

export default function ContactsSimpleSearch({ filter, setFilter }) {
  return (
    <>
      <div className="">
        <label className="form-label text-nowrap fw-bold text-white p-2">
          Status
        </label>
        <Input
          isMulti
          inputType="select"
          options={[
            ...(filter[1]?.values.length > 1
              ? []
              : [{ value: "all", label: "Show all" }]),
            { value: "active", label: "Active" },
            { value: "archived", label: "Archived" },
            { value: "incomplete", label: "Incomplete" },
          ]}
          placeholder="Show all"
          value={filter[1]?.values || []}
          onChange={(values) => {
            if (values.length === 0) {
              return;
            }
            setFilter((prev) => [
              prev[0],
              {
                fields: ["status"],
                formats: [],
                isOr: false,
                offset: "0",
                offsetFrom: "fixed",
                offsetType: "positive",
                offsetUnit: "day",
                operator: "is",
                order: 0,
                thread: "CurrentThread",
                timeZone: "",
                timeZoneFrom: "fixed",
                valueId: "",
                valueType: "fixed",
                values: values.includes("all")
                  ? ["active", "incomplete", "archived"]
                  : values,
              },
            ]);
          }}
        />
      </div>

      <div className="" style={{ minWidth: 300 }}>
        <label className="form-label text-nowrap fw-bold text-white p-2">
          Search fields
        </label>
        <Input
          isMulti
          inputType="select"
          placeholder="You need to select at least one field"
          options={[
            { value: "primary", label: "Primary" },
            { value: "card", label: "Card" },
            { value: "sms", label: "SMS" },
            { value: "email", label: "Email" },
            { value: "voice", label: "Voice" },
          ]}
          value={filter[0].formats}
          onChange={(values) => {
            setFilter((prev) => [
              {
                ...prev[0],
                formats: values,
              },
              prev[1],
            ]);
          }}
        />
      </div>
      <div className="">
        <label className="form-label text-nowrap fw-bold text-white p-2">
          Search method
        </label>
        <Input
          inputType="select"
          options={[
            { value: "prefix", label: "Starts with" },
            { value: "is", label: "Exact match" },
            {
              value: "contains",
              label: "Contains",
            },
            { value: "suffix", label: "Ends with" },
          ]}
          value={[filter[0].operator]}
          onChange={(values) => {
            setFilter((prev) => [
              {
                ...prev[0],
                operator: values[0],
              },
              prev[1],
            ]);
          }}
        />
      </div>

      <div className="">
        <label className="form-label text-nowrap fw-bold text-white p-2">
          Search / Add Contact
        </label>
        <div className="position-relative">
          <input
            placeholder="Enter name, phone number or email to start searching. Separate multiple items by commas."
            className="form-control"
            style={{ height: 40, paddingRight: 40, minWidth: 400 }}
            type="text"
            value={filter[0].values?.join(",") || ""}
            onChange={(e) =>
              setFilter((prev) => [
                {
                  ...prev[0],
                  values: [
                    ...new Set(e.target.value.split(",").map((v) => v.trim())),
                  ],
                },
                prev[1],
              ])
            }
          />
          <SearchIcon
            width={30}
            heigth={30}
            className="white bg-colored position-absolute top-50 end-0 translate-middle rounded-circle p-2"
            style={{ marginRight: -10 }}
          />
        </div>
      </div>
    </>
  );
}
